import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { extractApiError } from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Briefcase, ArrowLeft, Info } from "lucide-react";

export default function Opportunity() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    api.get("/opportunity/status").then((r) => setData(r.data))
       .catch((e) => setError(extractApiError(e, "Failed to load status.")));
  }, []);

  return (
    <AppShell>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <p className="text-xs uppercase tracking-wider text-fg-secondary">CRA3D Job Launch</p>
        <h1 className="mt-1 text-3xl sm:text-4xl font-heading font-medium text-fg-primary flex items-center gap-2" data-testid="opportunity-title">
          <Briefcase className="h-6 w-6" aria-hidden="true" />
          CRA3D Job Launch &mdash; Coming soon
        </h1>
        <p className="mt-3 text-sm text-fg-secondary max-w-2xl leading-relaxed" data-testid="opportunity-coming-soon">
          Job-launch tools are in development. Nothing here is live yet &mdash; the
          section below previews what CRA3D Job Launch is planned to support.
        </p>
        {error && <Alert variant="destructive" className="mt-6"><AlertDescription>{error}</AlertDescription></Alert>}
        {data && (
          <>
            <div className="mt-6 rounded-lg border border-accent-warm/40 bg-accent-warm/5 p-4" data-testid="opportunity-status">
              <p className="text-sm text-fg-primary font-medium" data-testid="opportunity-status-line">
                {data.status}
              </p>
              <p className="mt-2 text-xs text-fg-secondary">{data.disclosure}</p>
            </div>

            <section className="mt-8">
              <h2 className="text-xl font-heading font-medium text-fg-primary">What Job Launch is planned to support</h2>
              <p className="mt-1 text-xs text-fg-secondary">Framed as FUTURE — nothing here is live yet.</p>
              <ul className="mt-3 space-y-3">
                {Object.entries(data.eventual_scope || {}).map(([k, v]) => (
                  <li key={k} className="rounded-md border border-border-subtle bg-bg-surface p-3" data-testid={`opportunity-scope-${k}`}>
                    <p className="text-xs uppercase tracking-wider text-fg-secondary">{k.replace(/_/g, " ")}</p>
                    <p className="mt-1 text-sm text-fg-primary">{v}</p>
                  </li>
                ))}
              </ul>
            </section>

            <section className="mt-8">
              <h2 className="text-xl font-heading font-medium text-fg-primary flex items-center gap-2">
                <Info className="h-4 w-4" aria-hidden="true" />
                Data source status
              </h2>
              <ul className="mt-3 space-y-2">
                {Object.entries(data.adapters || {}).map(([name, info]) => (
                  <li key={name} className="rounded-md border border-border-subtle bg-bg-surface p-3 flex items-center justify-between" data-testid={`opportunity-adapter-${name}`}>
                    <p className="text-sm text-fg-primary uppercase">{name}</p>
                    <p className="text-xs text-fg-muted">
                      {info.configured ? "Configured" : "Not configured"} · {info.note}
                    </p>
                  </li>
                ))}
              </ul>
            </section>
          </>
        )}

        <div className="mt-8">
          <Link to="/dashboard">
            <Button variant="ghost" data-testid="opportunity-back-dashboard" className="text-fg-secondary hover:text-fg-primary hover:bg-bg-surface-hover">
              <ArrowLeft className="h-4 w-4 mr-2" aria-hidden="true" />
              Back to dashboard
            </Button>
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
